import { render, staticRenderFns } from "./DespesasEmEstoque.vue?vue&type=template&id=0155bf09&scoped=true&"
import script from "./DespesasEmEstoque.vue?vue&type=script&lang=js&"
export * from "./DespesasEmEstoque.vue?vue&type=script&lang=js&"
import style0 from "./DespesasEmEstoque.vue?vue&type=style&index=0&id=0155bf09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0155bf09",
  null
  
)

export default component.exports